import { useState, useEffect, useCallback } from 'react';
import { ApiFactory } from '../../core/config/ApiFactory';
import { IPedidoKDSExpedicao } from '../interfaces/IKDS';
import { useWebSocketKDSContext } from '../contexts/WebSocketKDSContext';

export const useKDSExpedicao = () => {
    const [pedidos, setPedidos] = useState<IPedidoKDSExpedicao[]>([]);
    const [loading, setLoading] = useState(false);
    const api = ApiFactory.getApi("MS_PEDIDOS");
    const { registrarCallback, removerCallback } = useWebSocketKDSContext();

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get('/kds/expedicao');
            setPedidos(res.data.pedidos ?? []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    const liberarPedido = useCallback(async (pedidoUuid: string) => {
        try {
            await api.patch(`/kds/pedido/${pedidoUuid}/liberar`);
            await carregar();
        } catch (e) {
            console.error(e);
        }
    }, [carregar]);

    const dispararPedido = useCallback(async (pedidoUuid: string) => {
        try {
            await api.post(`/kds/pedido/${pedidoUuid}/disparar`);
            await carregar();
        } catch (e) {
            console.error(e);
        }
    }, [carregar]);

    const dispararItemIndividual = useCallback(async (itemUuid: string) => {
        try {
            await api.patch(`/kds/item/${itemUuid}/disparar`);
            await carregar();
        } catch (e) {
            console.error(e);
        }
    }, [carregar]);

    const reverterItem = useCallback(async (uuid: string) => {
        try {
            await api.patch(`/kds/item/${uuid}/reverter`);
            await carregar();
        } catch (e) {
            console.error(e);
        }
    }, [carregar]);

    useEffect(() => {
        carregar();
        registrarCallback(carregar);
        const interval = setInterval(carregar, 15000);
        return () => {
            removerCallback(carregar);
            clearInterval(interval);
        };
    }, [carregar]);

    return { pedidos, loading, carregar, liberarPedido, dispararPedido, dispararItemIndividual, reverterItem };
};
